/** @jsx h */
import { h } from 'preact'
import { useState } from 'preact/hooks'
import BrandingWordmarkFlag from '../../../assets/images/svgs/branding-wordmark-flag.svg'
import BrandingWordmarkLogo from '../../../assets/images/svgs/branding-wordmark-logos.svg'

const PoweredByProvenance = ({ onAboutClick, embed }) => {
  if (typeof onAboutClick !== 'function') return null

  const [showLogo, setShowLogo] = useState(false)

  return (
    <div
      class={`TagLine TagLine--${embed ? 'embed' : 'noEmbed'}`}
      onMouseOver={() => { setShowLogo(true) }}
      onMouseLeave={() => { setShowLogo(false) }}
    >
      {!showLogo
        ? (
          <span class='TagLine-wordmark TagLine-click' onClick={onAboutClick(1)}>
            <BrandingWordmarkFlag onClick={onAboutClick ? onAboutClick(1) : ''} />
          </span>)
        : (
          <span class='TagLine-wordmark TagLine-click' onClick={onAboutClick(1)}>
            <BrandingWordmarkLogo onClick={onAboutClick ? onAboutClick(1) : ''} />
          </span>
          )}
    </div>
  )
}

export default PoweredByProvenance
